import { Check, X } from 'lucide-react'
import Card from '@/components/Card'
import SectionHead from '@/components/SectionHead'
import NamingBuilder, {
  NAMING_EXAMPLES,
} from '@/components/NamingBuilder'
import ExistingCampaignRename from './ExistingCampaignRename'
import { cn } from '@/lib/utils'

export default function NamingGenerator() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-[22px] font-bold tracking-tight text-[var(--foreground)]">
          Naming-Generator
        </h1>
        <p className="mt-1 text-sm text-[var(--muted-foreground)]">
          Vorschau für bestehende DE-SP-Kampagnen mit geprüftem PPC-Code, Produktfamilie und
          Targeting. Frühere Builder-Beispiele stehen darunter zum Kopieren.
        </p>
      </div>

      <ExistingCampaignRename />

      <div className="grid gap-4 lg:grid-cols-[1.2fr_1fr]">
        <Card className="p-4">
          <details>
            <summary className="cursor-pointer text-sm font-semibold text-[var(--foreground)]">Historischer Beispiel-Builder (nur zum Kopieren)</summary>
            <p className="mt-1 text-xs text-[var(--muted-foreground)]">Der Builder erstellt und benennt keine Kampagne um. Er dient ausschließlich zum Kopieren eines Beispiels.</p>
            <div className="mt-3"><NamingBuilder /></div>
          </details>
        </Card>

        <Card className="p-4">
          <SectionHead
            title="Historische Builder-Beispiele"
            subtitle="Frühere Namensmuster zum Nachschlagen. Die aktuelle Bestandsvorschau steht oben."
            className="mb-3"
          />
          <div className="rounded-md border border-[var(--border)] bg-[var(--muted)]/40 p-3 font-mono text-[11.5px] leading-relaxed text-[var(--foreground)]">
            <div>{'^\\d{2}_[A-Z]{2,5}_'}</div>
            <div>(SP|SB|SD)_</div>
            <div>(Auto | KW_(Exact|Phrase|Broad) | PAT | AUD)_</div>
            <div>{'\\w+$'}</div>
          </div>

          <ul className="mt-4 space-y-1.5">
            {NAMING_EXAMPLES.map((s) => (
              <li key={s.name} className="flex items-center gap-2 text-xs">
                {s.ok ? (
                  <Check className="h-3 w-3 shrink-0 text-emerald-500" />
                ) : (
                  <X className="h-3 w-3 shrink-0 text-red-500" />
                )}
                <span
                  className={cn(
                    'font-mono',
                    s.ok
                      ? 'text-[var(--foreground)]'
                      : 'text-[var(--muted-foreground)] line-through',
                  )}
                >
                  {s.name}
                </span>
                <span className="ml-auto text-[11px] text-[var(--muted-foreground)]">
                  {s.note}
                </span>
              </li>
            ))}
          </ul>
        </Card>
      </div>
    </div>
  )
}
